import { render, staticRenderFns } from "./CardList-speechArt.vue?vue&type=template&id=32d6d2a9&"
import script from "./CardList-speechArt.vue?vue&type=script&lang=js&"
export * from "./CardList-speechArt.vue?vue&type=script&lang=js&"
import style0 from "./CardList-speechArt.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports